import { motion } from "motion/react";
import { Outlet } from "react-router";
import { SFullAppProvider } from "@/pages/SEmbed/SFullAppProvider";

export function EmbeddingLayout() {
  return (
    <SFullAppProvider>
      {/* Follows the theme, so no light frame shows around S while it loads dark. */}
      <div className="flex flex-col h-full bg-background">
        <motion.div
          className="flex flex-col h-full"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.75, ease: "easeInOut" }}
        >
          <div className="flex flex-1 overflow-hidden">
            <Outlet />
          </div>
        </motion.div>
      </div>
    </SFullAppProvider>
  );
}
